import { type ReactElement } from 'react';

import { QueryErrorDisplay } from '../components/error-display';

type UseQueryErrorHandlingResult = {
  errorComponent: ReactElement | null;
  hasError: boolean;
};

export const useQueryErrorHandling = (
  queryResult: { error?: unknown; refetch: () => void },
  onRetry?: () => void
): UseQueryErrorHandlingResult => {
  const { error, refetch } = queryResult;

  if (error) {
    return {
      errorComponent: (
        <QueryErrorDisplay error={error} onRetry={onRetry ?? (() => void refetch())} />
      ),
      hasError: true
    };
  }

  return {
    errorComponent: null,
    hasError: false
  };
};
